import * as Yup from 'yup';

export default Yup.object().shape({
  firstName: Yup.string().required('First Name is required').max(100),
  lastName: Yup.string().required('Last Name is required').max(100),
  // pin: Yup.string().required('Pin is required').min(4).max(4),
  roleId: Yup.number().nullable().required('Please select a Role for the user'),
  email: Yup.string().email('Please enter valid email').required('Email is required').max(250),
  isActive: Yup.bool().nullable(),
});